module.exports = __webpack_public_path__ + "24123b43dff003249a99beb8a612368a.pdf";